export default __webpack_public_path__ + "images/View_of_Lower_Limb.fdf8ac45080225032f7c895e47f204e8.png";